import React, { Component } from 'react';
import { history } from 'store';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { siteMenuConfig } from 'config/menu.config';
import settings from 'settings';
import { toggleMenu } from 'actions/site';
import AuthService from 'library/authService/auth-service';
import { Notifications } from 'components/Notifications';
import OptimiserStatusBadge from 'components/OptimiserStatusBadge';
import OptimiserFinishedNotification from 'components/OptimiserFinishedNotification';
import { Icon } from 'antd';
import SiteLogo from './site-logo';
import SiteMenu from './site-menu';
import SubMenu from './sub-menu';
import QuickLinks from './quick-links';
import ProfileMenu from './profile-menu';

const getChildMenu = (parent, url) => {
  const segments = url.split('/')
    .filter(v => v !== '');
  return parent.children.find(child => (
    (
      url.indexOf(child.href) !== -1
      || child.href.indexOf(`/${segments[0]}/${segments[1]}/`) !== -1
      || child.href.indexOf(`/${segments[1]}/${segments[2]}/`) !== -1
      || child.children.includes(`/${segments[0]}/${segments[1]}/`)
      || child.children.includes(`/${segments[1]}/${segments[2]}/`)
    )
  ));
};

const getMenuByUrl = (url) => {
  const parent = siteMenuConfig.find(item => getChildMenu(item, url)) || null;
  const child = parent ? getChildMenu(parent, url) : null;
  return {
    parent,
    child
  };
};
const getDefaultSubMenu = (url) => {
  const { parent, child } = getMenuByUrl(url);

  if (child && child.visible()) {
    const childUrl = child.children.find(item => url.indexOf(item) !== -1);
    return childUrl ? {
      href: url,
      name: child.name
    } : child;
  }
  if (child && parent) {
    return parent.children.find(item => item.visible()); // get first visible child
  }

  return { href: url }; // get existing menu based on window.location.pathname
};

const mapDispatchToProps = dispatch => ({
  toggleMobileMenu() {
    dispatch(toggleMenu());
  }
});

const mapStateToProps = state => ({
  toggle: state.site.menu
});

class SiteHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMenuItem: {},
      selectedSubMenuItem: {},
      quickLinks: {
        showNotifications: false,
        showSettings: false,
        showProfile: false
      }
    };

    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleSubMenuItemClick = this.handleSubMenuItemClick.bind(this);
    this.handleQuickLinkClick = this.handleQuickLinkClick.bind(this);
  }

  setMenuItem(menuItem) {
    const entryPoint = getDefaultSubMenu(menuItem.href);
    const { parent } = getMenuByUrl(menuItem.href);

    this.setState({
      selectedMenuItem: parent,
      selectedSubMenuItem: entryPoint
    },
    () => {
      history.push(entryPoint.href);
    });
  }

  updateMenuState(pathname) {
    const entryPoint = getDefaultSubMenu(pathname);
    const { parent } = getMenuByUrl(pathname);
    this.setState({
      selectedMenuItem: parent,
      selectedSubMenuItem: entryPoint
    });
  }

  UNSAFE_componentWillMount() {
    this.setMenuItem({ href: window.location.pathname.replace(settings.BASE_URI(), '/') });
  }

  componentDidMount() {
    this.unlistenHistory = history.listen((location) => {
      this.updateMenuState(location.pathname);
    });
  }

  componentWillUnmount() {
    if (this.unlistenHistory) {
      this.unlistenHistory();
    }
  }

  handleMenuItemClick(menuItem) {
    this.setMenuItem(menuItem);
  }

  handleSubMenuItemClick(menuItem) {
    history.push(menuItem.href);
    this.setState({
      selectedSubMenuItem: menuItem
    });
  }

  handleQuickLinkClick(itemName) {
    this.setState(prevState => ({
      quickLinks: {
        showNotifications: itemName === 'notifications' && !prevState.quickLinks.showNotifications,
        showSettings: itemName === 'settings' && !prevState.quickLinks.showSettings,
        showProfile: itemName === 'profile' && !prevState.quickLinks.showProfile
      }
    }));
  }

  render() {
    const { toggle, toggleMobileMenu } = this.props;
    const { selectedMenuItem, selectedSubMenuItem, quickLinks } = this.state;
    const user = AuthService.whoami() || {};
    const currentTenancy = user.currentTenancy || {};
    const subMenu = selectedMenuItem ? selectedMenuItem.children : [];

    return (
      <div className="bhp-site-header">
        <SiteLogo />
        <div
          className="bhp-burger__menu"
          onClick={() => {
            this.handleQuickLinkClick('profile');
            toggleMobileMenu();
          }}
        >
          <Icon type={toggle ? 'cross' : 'menu'} />
        </div>
        <SiteMenu
          dataSource={siteMenuConfig}
          selectedKeys={[selectedMenuItem ? selectedMenuItem.name : '']}
          onMenuItemClick={this.handleMenuItemClick}
        />
        <QuickLinks>
          <QuickLinks.Clock />
          <QuickLinks.SiteInfo
            siteName={currentTenancy.tenancyName}
          />
          <Notifications classes="bhp-quicklinks-item bhp-icon" icon="notification" showBadge />
          <OptimiserStatusBadge classes="bhp-quicklinks-item bhp-icon" />
          <QuickLinks.HelpDocumentation />
          <QuickLinks.ProfileLink
            name={user.displayName}
            active={quickLinks.showProfile}
            onClick={() => this.handleQuickLinkClick('profile')}
          />
        </QuickLinks>
        <ProfileMenu active={quickLinks.showProfile} />
        <SubMenu
          dataSource={subMenu}
          selectedKeys={[selectedSubMenuItem ? selectedSubMenuItem.name : '']}
          onMenuItemClick={this.handleSubMenuItemClick}
        />
        <OptimiserFinishedNotification />
      </div>
    );
  }
}

SiteHeader.propTypes = {
  toggleMobileMenu: PropTypes.func,
  toggle: PropTypes.bool
};

SiteHeader.defaultProps = {
  toggleMobileMenu() {
  },
  toggle: false
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteHeader);
